var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 8C23.5 4.55664 17.9941 0 12 0C6.00594 0 0.5 4.55664 0.5 8C0.5 11.4434 6.00594 16 12 16C17.9941 16 23.5 11.4434 23.5 8ZM2.5 8C2.5 5.7537 7.03573 2 12 2C13.3142 2 14.5984 2.26307 15.7763 2.69161L6.1424 12.3255C3.96559 11.0408 2.5 9.27688 2.5 8ZM8.22368 13.3084C9.40161 13.7369 10.6858 14 12 14C16.9643 14 21.5 10.2463 21.5 8C21.5 6.72312 20.0344 4.95916 17.8576 3.67446L8.22368 13.3084Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.1891cba40d321e57a571a89beb54c62b.svg";
export { ForwardRef as ReactComponent };